import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { BaseService } from '../core/base/base.service';

@Injectable({
  providedIn: 'root'
})
export class ForbiddenService extends BaseService {

  constructor(override store: Store<any>) {
    super();
  }

}
